/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconArrowUpCircle = createReactComponent("outline", "arrow-up-circle", "IconArrowUpCircle", [["path", { "d": "M12 17v-14", "key": "svg-0" }], ["path", { "d": "M15 6l-3 -3l-3 3", "key": "svg-1" }], ["path", { "d": "M12 17a2 2 0 1 0 0 4a2 2 0 0 0 0 -4", "key": "svg-2" }]]);

export { IconArrowUpCircle as default };
//# sourceMappingURL=IconArrowUpCircle.mjs.map
